import React, { useState, useEffect } from "react";
import {
  Elements,
  CardElement,
  useElements,
  useStripe,
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import DEATH_API from "../../apis/death.api";
import Loader from "../../components/styled-components/loader/loader";
import swal from "sweetalert";
import { useHistory, useLocation } from "react-router-dom";
import "../StripePayment/checkoutForm.css";

const stripePromise = loadStripe("pk_live_wKCw9yisXYK24d46u573Nhql00SmHvFQlO"); // live key
// const stripePromise = loadStripe("pk_test_51RP1DoFPCqXGd6eyq2L1o2Gu7y7vY5fuVNqoo6McnegHn7aS9heWWhYSQFJtoyxLYXpovlblPAuhKfrX04vb2fLO00MYnsmyJS"); // stage key

const PaymentForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(false);
  const [defaultCard, setDefaultCard] = useState(false);

  const makeDefault = [
    { id: 1, name: "Yes" },
    { id: 1, name: "No" },
  ];

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    const payload = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardNumberElement),
    });
    console.log("[PaymentMethod]", payload);
    if (payload.error) {
      swal("ERROR", payload.error.message, "error");
    } else if (payload.paymentMethod) {
      await addCard(payload.paymentMethod.id);
      if(defaultCard==="Yes"){
        await updateCard(payload.paymentMethod.id)
      }
      await props.submit();
    }
  };

  const addCard = async (tokenId) => {
    try {
      setLoading(true);
      let datares = await DEATH_API.addCustomerCard({ token: tokenId });
      console.log("datares", datares);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handleOnChange = (name) => {
    console.log("default card", name);
    setDefaultCard(name);
  };

  const updateCard = async (pmKey) => {
    try {
      setLoading(true);
      let datares = await DEATH_API.makeDefaultCard({ paymentMethod: pmKey });
      console.log("datares", datares);
      if(datares && datares.status===200){
        swal("Success",datares.message,"success" )
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  // const handleSubmit = async (event) => {
  //   event.preventDefault();

  //   if (!stripe || !elements) {
  //     return;
  //   }

  //   setLoading(true);

  //   const cardElement = elements.getElement(CardNumberElement);

  //   try {
  //     const { token, error } = await stripe.createToken(cardElement);

  //     if (error) {
  //       throw new Error(error.message);
  //     }

  //     console.log("[Token]", token);
  //     props.submit();
  //     // Here, you can send the token to your server and handle the payment process

  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     console.error("Error creating token:", error.message);
  //     // Handle the error accordingly, e.g., display an error message to the user
  //   }
  // };
  const inputStyle = {
    iconColor: "#c4f0ff",
    color: "black",
    fontWeight: "500",
    fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
    fontSize: "16px",
    fontSmoothing: "antialiased",
    "::placeholder": {
      color: "#C1C1C7",
    },

    invalid: {
      iconColor: "#FFC7EE",
      color: "red",
    },
  };
  return (
    <React.Fragment>
      <form
        style={{ width: "100%" }}
        // onSubmit={handleSubmit}
      >
        <label className="labelStyleCheckout" style={{ width: "100%" }}>
          <h3
            style={{
              color: "#4d5e80",
              marginBottom: "10px",
              fontSize: "14px",
              fontFamily: "Poppins",
              lineHeight: "20px",
              fontWeight: "700",
            }}
          >
            Credit Card Number
          </h3>
          <div className="inputStyleCheckout" style={{ marginTop: "4px" }}>
            <CardNumberElement
              options={{
                style: {
                  base: inputStyle,
                },
              }}
              onReady={() => {
                console.log("CardNumberElement [ready]");
              }}
              onChange={(event) => {
                console.log("CardNumberElement [change]", event);
              }}
              onBlur={() => {
                console.log("CardNumberElement [blur]");
              }}
              onFocus={() => {
                console.log("CardNumberElement [focus]");
              }}
            />
          </div>
        </label>
        <label className="labelStyleCheckout" style={{ width: "100%" }}>
          <h3
            style={{
              color: "#4d5e80",
              marginBottom: "10px",
              fontSize: "14px",
              fontFamily: "Poppins",
              lineHeight: "20px",
              fontWeight: "700",
            }}
          >
            {" "}
            Expiration{" "}
          </h3>
          <div className="inputStyleCheckout" style={{ marginTop: "4px" }}>
            <CardExpiryElement
              options={{
                style: {
                  base: inputStyle,
                },
              }}
              onReady={() => {
                console.log("CardNumberElement [ready]");
              }}
              onChange={(event) => {
                console.log("CardNumberElement [change]", event);
              }}
              onBlur={() => {
                console.log("CardNumberElement [blur]");
              }}
              onFocus={() => {
                console.log("CardNumberElement [focus]");
              }}
            />
          </div>
        </label>
        <label className="labelStyleCheckout" style={{ width: "100%" }}>
          <h3
            style={{
              color: "#4d5e80",
              marginBottom: "10px",
              fontSize: "14px",
              fontFamily: "Poppins",
              lineHeight: "20px",
              fontWeight: "700",
            }}
          >
            {" "}
            CVC{" "}
          </h3>
          <div className="inputStyleCheckout" style={{ marginTop: "4px" }}>
            <CardCvcElement
              options={{
                style: {
                  base: inputStyle,
                },
              }}
              onReady={() => {
                console.log("CardNumberElement [ready]");
              }}
              onChange={(event) => {
                console.log("CardNumberElement [change]", event);
              }}
              onBlur={() => {
                console.log("CardNumberElement [blur]");
              }}
              onFocus={() => {
                console.log("CardNumberElement [focus]");
              }}
            />
          </div>
        </label>
        <label
          className="labelStyleCheckout"
          style={{ display: "inline-grid", width: "100%", marginTop: "4px" }}
        >
          <h3
            style={{
              color: "#4d5e80",
              marginBottom: "10px",
              fontSize: "14px",
              fontFamily: "Poppins",
              lineHeight: "20px",
              fontWeight: "700",
            }}
          >
            {" "}
            Name on Card{" "}
          </h3>
          <div className="inputStyleCheckoutPromo" style={{ display: "flex" }}>
            <input
              name="name"
              placeholder="Name on Card"
              className="inputStylepromo"
              style={{ width: "100%" }}
              // onChange={handlePromotionCodeChange}
            />
          </div>
        </label>
        <h3
          style={{
            color: "#4d5e80",
            marginBottom: "10px",
            fontSize: "14px",
            fontFamily: "Poppins",
            lineHeight: "20px",
            fontWeight: "700",
          }}
        >
          {" "}
          Make as Default{" "}
        </h3>
        <div
          style={{
            width: "34%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {makeDefault &&
            makeDefault.map((item, index) => (
              <div
                key={index}
                style={{ marginTop: "1rem", marginBottom: "1rem" }}
              >
                <label class="container1">
                  <input
                    type="radio"
                    id={item.id}
                    name="check"
                    value={item.name}
                    // checked={isChecked}
                    onChange={() => {
                      handleOnChange(item.name);
                    }}
                  />
                  <span class="checkmark"></span>
                  <div style={{ fontSize: "16px" }}>{item.name} </div>
                </label>
              </div>
            ))}
        </div>
      </form>
      <div className="buttonsMain">
        <button
          className="cancelbutton"
          onClick={() => {
            props.close();
          }}
        >
          Cancel
        </button>
        <button className="savebutton" onClick={handleSubmit}>
          Save
        </button>
      </div>
      <Loader isLoading={loading} />

      {/*<CardElement />
      <button
        className="savebutton"
        style={{ marginTop: "1rem" }}
        onClick={handleSubmit(stripe, elements)}
      >
        Buy
      </button>*/}
    </React.Fragment>
  );
};

const StripePaymentForm = (props) => (
  <Elements stripe={stripePromise}>
    <div className="checkoutCard1">
      <div className="checkoutCardInner1">
        <PaymentForm submit={props.submit} close={props.close} />
      </div>
    </div>
  </Elements>
);

export default StripePaymentForm;
